import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export default function ProjectBoxOffer({ from, to, passengers, prix, min }) {
  const { t } = useTranslation();
  return (
    <Wrapper className="fhjIPf ">
      <p className="font131 extraBold textCenter" style={{ marginTop: "30px" }}>
        {t("originAddress")} :
      </p>
      <p className="textCenter">{from}</p>

      <p className="font131 extraBold textCenter">
        {t("destinationAddress")} :
      </p>
      <p className="font15 textCenter">{to}</p>

      <p className="font131 extraBold textCenter">
        {t("PassagersandLuaguage")} :{" "}
      </p>
      <p className="textCenter">{passengers}</p>

      <p className="font131 extraBold textCenter">{t("prix")} : </p>
      <p
        className="textCenter extraBold"
        style={{ color: "#eac418", fontSize: 20 }}
      >
        {prix}
      </p>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 190px;
  padding: 1px;
  max-width: 480px;
  background: white;
  border-radius: 25px;
  padding: 0px
  margin-top: 300px;
  box-shadow: 0px 2px 4px rgb(0, 0, 0,0.1);
  img {
    max-width: 200px;
    max-height: 190px;    
    margin: 20px 0;
  }
  h3 {
    padding-bottom: 10px;
  }
`;
